import { render, staticRenderFns } from "./CreateStudentNotify.vue?vue&type=template&id=7eb2ed5e&scoped=true"
import script from "./CreateStudentNotify.vue?vue&type=script&lang=js"
export * from "./CreateStudentNotify.vue?vue&type=script&lang=js"
import style0 from "./CreateStudentNotify.vue?vue&type=style&index=0&id=7eb2ed5e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb2ed5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eb2ed5e')) {
      api.createRecord('7eb2ed5e', component.options)
    } else {
      api.reload('7eb2ed5e', component.options)
    }
    module.hot.accept("./CreateStudentNotify.vue?vue&type=template&id=7eb2ed5e&scoped=true", function () {
      api.rerender('7eb2ed5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/CreateStudentNotify.vue"
export default component.exports